<div class="pb-4">
  <div class="row my-5">
    <div class="col-12">
      <lib-filter-list #orderList [configService]="orderListConfigService"> </lib-filter-list>
    </div>
  </div>
</div>
